import { render, staticRenderFns } from "./MarketingPreferencesAttributesRevisionTab.vue?vue&type=template&id=0339a746&scoped=true&"
import script from "./MarketingPreferencesAttributesRevisionTab.vue?vue&type=script&lang=js&"
export * from "./MarketingPreferencesAttributesRevisionTab.vue?vue&type=script&lang=js&"
import style0 from "./MarketingPreferencesAttributesRevisionTab.vue?vue&type=style&index=0&id=0339a746&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0339a746",
  null
  
)

export default component.exports